import { SortingState } from '@tanstack/react-table'

export type ConnectionResult<TItem> = {
  totalCount?: number | null
  startCursor?: string | null
  endCursor?: string | null
  hasNextPage?: boolean | null
  hasPreviousPage?: boolean | null
  items: TItem[]
}

export type ConnectionQueryOptions<TFilter, TOrderBy> = {
  pageIndex: number
  pageSize: number
  sorting?: SortingState
  filter?: TFilter
  orderBy?: TOrderBy[]
}

export const getConnectionQueryVariables = <TFilter, TOrderBy>({
  pageIndex,
  pageSize,
  sorting,
  filter,
  orderBy,
}: ConnectionQueryOptions<TFilter, TOrderBy>) => ({
  first: pageSize,
  skip: pageIndex * pageSize,
  filter,
  orderBy: orderBy ?? sorting,
})

export const getConnectionPageCount = (
  totalCount: number | null | undefined,
  pageSize: number,
) => {
  if (!totalCount || pageSize <= 0) {
    return 1
  }

  return Math.max(1, Math.ceil(totalCount / pageSize))
}

export const unwrapConnectionItems = <TItem>(
  connection?: ConnectionResult<TItem> | null,
) => connection?.items ?? []
